import ReportProperty from '@/Enums/Report/BeeswaxReportProperties.enum';
import ReportView from '@/Enums/ReportingDashboard/ReportView/ReportView.enum';
import type { ITotalReportRecord } from '@/Interfaces/ReportingDashboard/Social/ReportRecord.interface';
import type { IState } from '@/Interfaces/Slices/ReportingDashboard/Social/State.interface';
import type { SocialReportView } from '@/types/ReportingDashboard/Social.type';
import { DEFAULT_LOADING_REQUEST_ID } from '../slice';

export const defaultTotals: ITotalReportRecord = {
  [ReportProperty.IMPRESSIONS]: 0,
  [ReportProperty.CTR]: 0,
  [ReportProperty.COST_PER_CLICK]: 0,
  [ReportProperty.COST_PER_IMPRESSION]: 0,
  [ReportProperty.ENGAGEMENT_RATE]: 0,
  [ReportProperty.VCR]: 0,
};

export const initialState: IState = {
  //#region report data
  totals: defaultTotals,

  //#region grid
  dateReport: [],
  platformReport: [],
  advertiserReport: [],
  agencyReport: [],
  campaignReport: [],
  adNameReport: [],
  placementReport: [],
  //#endregion

  //#endregion

  //#region filters
  campaigns: [],
  //#endregion

  //#region requestIds
  totalsRequestId: DEFAULT_LOADING_REQUEST_ID,

  //#region grid
  dateReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  platformReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  advertiserReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  agencyReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  campaignReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  adNameReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  placementReportRequestId: DEFAULT_LOADING_REQUEST_ID,
  //#endregion
  //#endregion

  errorCardMessage: '',
};

export const allowedSocialTablesToPrint: SocialReportView[] = [
  ReportView.Date,
  ReportView.Platform,
  ReportView.Agency,
  ReportView.Advertiser,
  ReportView.Campaign,
  ReportView.Placement,
  ReportView.AdName,
];

export const socialImpressionTypes = [
  ReportView.Date,
  ReportView.Platform,
  ReportView.Agency,
  ReportView.Advertiser,
  ReportView.Campaign,
  ReportView.Placement,
  ReportView.AdName,
].map(view => ({ label: view, value: view }));
